import { render } from "./PFaceQRLink.vue?vue&type=template&id=ddba20e8"
import script from "./PFaceQRLink.vue?vue&type=script&lang=js"
export * from "./PFaceQRLink.vue?vue&type=script&lang=js"

import "./PFaceQRLink.vue?vue&type=style&index=0&id=ddba20e8&lang=scss"
script.render = render

export default script